import React, {useEffect} from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import {Box} from "@mui/material";
import Tour from "./Tour";
import {useLanguage} from "../../LanguageContext";
import {sectionTitle} from "../styles/CommonStyles";

const upcomingGroupTourContainer = {
    alignItems: "center",
    justifyContent: "center",
    padding: '20px',
    width: '100%',
    minWidth: '100%',
};

const upcomingToursSection = {
    width: {
        xs: '100%',
        md: '80%',
    },
    marginLeft: {
        xs: '0%',
        md: '10%',
    },
};
const UpcomingGroupToursContainer = ({title, tours, titleVariant}) => {
        useEffect(() => {
            const savedScrollPosition = sessionStorage.getItem("scrollPosition");

            if (savedScrollPosition) {
                window.scrollTo(0, parseInt(savedScrollPosition, 10));
            } else {
                window.scrollTo(0, 0); // Reset to top if navigating normally
            }
        }, []);

        const {t} = useLanguage();

        const sortedTours = [...tours].sort((a, b) => {
            const today = new Date();
            const dateA = new Date(t(a.date));
            const dateB = new Date(t(b.date));

            const isPastA = dateA < today;
            const isPastB = dateB < today;

            if (isPastA !== isPastB) {
                return isPastA ? 1 : -1; // Move past dates to the end
            }

            if (a.active !== b.active) {
                return a.active ? -1 : 1; // Active tours come first, then inactive
            }
            return dateA - dateB; // Sort by date within each category
        });

        return (
            <Box sx={upcomingGroupTourContainer}>
                <Box textAlign={'center'} pb={'24px'}>
                    <Typography
                        sx={{
                            ...sectionTitle,
                            ...({color: titleVariant})
                        }}>
                        {t(title)}
                    </Typography>
                </Box>
                <Box
                    sx={upcomingToursSection}>
                    <Grid pt={'2opx'} container spacing={10}>
                        {sortedTours.map((tour) => (
                            <Grid item xs={12} sm={6} md={6} xl={4} key={tour.id}>
                                <Tour tour={tour}/>
                            </Grid>
                        ))}
                    </Grid>
                </Box>

            </Box>
        );
    }
;

export default UpcomingGroupToursContainer;
